import React from "react";
import { Link } from "react-router-dom";
import { QUOTE_STATUSES, statusOf, ONGOING, isOngoing } from "@/lib/quoteStatus";

export function StatusBadge({ qt }) {
  const s = isOngoing(qt) ? ONGOING : statusOf(qt);
  const cls = `inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${s.badge}`;
  if (s.key === "paid") { // paid lives on the Invoices page
    return <Link to="/invoices" data-testid={`quote-status-badge-${qt.id}`} data-status="paid" className={`${cls} hover:bg-emerald-500/25`} title="Managed on the Invoices page">Paid · Invoices <span className="font-zh normal-case tracking-normal opacity-80">已付款</span></Link>;
  }
  return (
    <span data-testid={`quote-status-badge-${qt.id}`} data-status={s.key} className={cls}>
      {s.key === "ongoing" && <span className="w-1.5 h-1.5 rounded-full bg-rose-400 animate-pulse" />}
      {s.en} <span className="font-zh normal-case tracking-normal opacity-80">{s.zh}</span>
    </span>
  );
}

// Draft / Approved only — "Paid" is set by marking the invoice as paid (Invoices page), never here
const PICKABLE = QUOTE_STATUSES.filter((s) => s.key !== "paid");

export function StatusPicker({ qt, onChange }) {
  const current = statusOf(qt).key;
  if (current === "paid") {
    return (
      <div className="space-y-1.5" data-testid={`quote-status-picker-${qt.id}`}>
        <p className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Status · 状态</p>
        <p className="text-xs text-emerald-300" data-testid={`quote-status-paid-note-${qt.id}`}>Paid via invoice{qt.invoice_no ? ` ${qt.invoice_no}` : ""} · 已付款 — manage on the Invoices page.</p>
      </div>
    );
  }
  return (
    <div className="space-y-1.5" data-testid={`quote-status-picker-${qt.id}`}>
      <p className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Status · 状态 <span className="normal-case tracking-normal font-normal text-slate-600">· paid is set from the invoice</span></p>
      <div className="flex rounded-lg border border-slate-700 bg-slate-950/60 p-0.5">
        {PICKABLE.map((s) => (
          <button key={s.key} data-on={current === s.key} onClick={() => current !== s.key && onChange(s.key)} data-testid={`quote-status-${s.key}-${qt.id}`}
            className={`flex-1 px-2 py-1.5 rounded-md text-xs font-semibold text-slate-400 transition-colors ${s.active}`}>
            {s.en} <span className="font-zh text-[10px] opacity-80 hidden lg:inline">{s.zh}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
